module.exports = __webpack_public_path__ + "img/trash.ddef8cf5.svg";